export const initialValues: IMyLoginCommand = {phoneNumber: ''};
